import actions from "../actions/actionTypes";

const preferencesReducer = (state = {}, action) => {
  if (action.type === actions.SET_PREFERENCES) {
    return action.payload;
  }
  return state;
};

export default preferencesReducer;
